module.exports = "@media screen and (max-width: 410px) {\nmd-icon{\n    display: none;\n}\nmd-card-title{\n    font-size: 10px !important;\n}\n}\n\n.blue-link a{\n    color: #337ab7 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/user-activity/user-activity.component.css
// module id = ./src/app/dashboard/user-activity/user-activity.component.css
// module chunks = main